import {
  IS_STACKED_BAR_CHART,
  IS_STACKED_BAR_HORIZONTAL_CHART
} from "constants/chart.constants";

import { DataEnum } from "models";

import {
  AXIS_TYPE,
  IS_BOX_PLOT_CHART,
  IS_CROSS_PLOT_CHART,
  IS_TREND_DATE_CHART
} from "../constants";
import { EvaChart } from "../constants/charts.enums";
import { ChartAxisType } from "../models/chart";

/**
 * Determines the allowed data types for chart axes group by based on chart type.
 * This is used to filter out specific data types in the group by that are not applicable for
 * the selected chart type.
 *
 * @param {ChartAxisType} axisType - The axis type, either "x" or "y".
 * @param {EvaChart} chartType - The type of chart being rendered.
 * @returns {string[]} An array of allowed data types for the specified axis.
 */
export const getAxisDataType = (
  axisType: ChartAxisType,
  chartType: EvaChart
): string[] => {
  const isProbit = chartType === EvaChart.Probit;
  const isBoxPlot = IS_BOX_PLOT_CHART(chartType);
  const isCrossPlot = IS_CROSS_PLOT_CHART(chartType);
  const isStackedBar = IS_STACKED_BAR_CHART(chartType);
  // Opposite axis assignment from StackedBar — see useAxisDataTypeFilter.
  const isStackedBarHorizontal = IS_STACKED_BAR_HORIZONTAL_CHART(chartType);
  const isDateTrend = IS_TREND_DATE_CHART(chartType);

  if (axisType === AXIS_TYPE.x) {
    return [
      ...(isCrossPlot ? [DataEnum.Number, DataEnum.Integer, DataEnum.Date] : []),
      ...(isProbit ? [DataEnum.Number, DataEnum.Integer] : []),
      ...(isDateTrend ? [DataEnum.Date, DataEnum.Integer] : []),
      ...(isStackedBarHorizontal ? [DataEnum.Number, DataEnum.Integer] : [])
    ];
  } else {
    return [
      ...(isCrossPlot ? [DataEnum.Number, DataEnum.Integer] : []),
      ...(isBoxPlot || isStackedBar || isDateTrend
        ? [DataEnum.Number, DataEnum.Integer]
        : [])
    ];
  }
};
